import { notification, Modal, Result, message, Tag, Avatar } from "antd";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"; // Import xlsx library
import moment from "moment";
import dayjs from "dayjs";
import { getCookie, getValidateMerchant, logout, setCookie } from "./config/authsave";
import {
  AndroidOutlined,
  AppleOutlined,
  CopyOutlined,
  LinuxOutlined,
  ToolOutlined,
  WindowsOutlined,
} from "@ant-design/icons";
import { tagsBageStatus } from "./helpers/tagsBage";
import { BankData } from "./Data/BankData";
import { getIcon } from "./helpers/getIcon";
import { t } from "i18next";
import Api from "./api/Api";
import config from "./config/app.config";
import { NotificationSound } from "./helpers/FunSetupBalanceNotifications";

export const handleLogoutAndAlert = (msg, title, type) => {
  let icon = !type ? "error" : type;
  let header = !title ? "Error!" : title;
  Swal.fire({
    icon: icon,
    title: header,
    text: msg,
  })
    .then((res) => {
      if (res.isConfirmed || res.isDismissed) {
        logout();
      }
    })
    .catch((error) => {
      console.log(error);
      logout();
    });
};
export const handleSwalTokenExpired = (title, msg) => {
  Swal.fire({
    icon: "warning",
    title: t(title),
    text: t(msg),
  })
    .then((result) => {
      if (result.isConfirmed || result.isDismissed) {
        logout();
      }
    })
    .catch((error) => {
      console.log(error);
      logout();
    });
};
// ฟังก์ชันจำลองการ logout
const funLogout = () => {
  logout();
};
/**
 * @param {string} params
 */
export const getRandomuserParams = (params) => {
  const { pagination, filters, sortField, sortOrder, ...restParams } = params;
  const result = {};

  result.limit = pagination?.pageSize;
  result.page = pagination?.current;

  // Filtering parameters
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        result[key] = value;
      }
    });
  }

  // Sorting parameters
  if (sortField) {
    result.orderby = sortField;
    result.order = sortOrder === "ascend" ? "asc" : "desc";
  }

  // Handle any other remaining parameters
  Object.entries(restParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      result[key] = value;
    }
  });

  return result;
};

/**
 * @param {string} params
 */
export const getApiParams = (params) => {
  const { pagination, filters, sortField, sortOrder, ...restParams } = params;
  const result = {};

  result.limit = pagination?.pageSize;
  result.page = pagination?.current;

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        result[key] = value.join(",");
      } else if (value !== undefined && value !== null && value !== "") {
        result[key] = value;
      }
    });
  }

  if (sortField) {
    result.orderby = sortField;
    result.order = sortOrder === "ascend" ? "asc" : "desc";
  }

  if (
    filters.customer_uuid !== undefined &&
    filters.customer_uuid !== null &&
    filters.customer_uuid !== ""
  ) {
    result.search = filters.customer_uuid;
  }

  if (
    filters.status !== undefined &&
    filters.status !== null &&
    filters.status !== ""
  ) {
    result.admin_status = filters.status;
  }

  Object.entries(restParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
  });

  return result;
};

/**
 * @param {string} record
 */
export const toURLSearchParams = (record) => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(record)) {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        params.append(key, value.join(","));
      }
    } else if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  }
  return params;
};

/**
 * แสดง Toast Notification
 * @param {('success'|'error'|'warning'|'info'|'loading')} type - ประเภทของ Toast (ใช้แทน icon)
 * @param {string} title - ข้อความที่ต้องการแสดงใน Toast
 *
 * ตัวอย่างการเรียกใช้:
 * showToast('success', 'บันทึกข้อมูลสำเร็จ!');
 * showToast('error', 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
 */
export const showToast = (type, title) => {
  // กำหนดประเภทของ Toast ที่ถูกต้อง
  const validTypes = ["success", "error", "warning", "info", "loading"];

  // 1. ตรวจสอบว่า 'message' มีอยู่จริง
  // 2. ตรวจสอบว่า 'type' เป็นประเภทที่ถูกต้องและเป็นฟังก์ชันใน 'message'
  if (
    typeof message === "object" &&
    message !== null &&
    validTypes.includes(type)
  ) {
    // เรียกใช้ฟังก์ชันที่ตรงกับ 'type' โดยตรง
    // เช่น ถ้า type เป็น 'success', จะเป็นการเรียก message.success(title)
    message[type](title);
  } else if (
    typeof message === "object" &&
    message !== null &&
    typeof message[type] === "function"
  ) {
    // ทางเลือก: หากไลบรารีของคุณมีชื่อฟังก์ชันที่หลากหลาย
    message[type](title);
  } else {
    // จัดการกับกรณีที่ 'message' หรือ 'type' ไม่ถูกต้อง
    console.error(
      `ไม่สามารถแสดง Toast: message object ไม่ถูกกำหนด, หรือประเภท '${type}' ไม่ถูกต้อง.`,
    );
  }
};

/**
 * แสดง Toast Notification
 * @param {('success'|'error'|'warning'|'info'|'loading')} type - ประเภทของ Toast (ใช้แทน icon)
 * @param {string} content - ข้อความที่ต้องการแสดงใน Toast
 *
 * ตัวอย่างการเรียกใช้:
 * showToast('success', 'บันทึกข้อมูลสำเร็จ!');
 * showToast('error', 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
 */
export const showMessage = (type, content) => {
  message[type]({
    content: content || "Unknown",
    duration: 8,
  });
};
/**
 * ฟังก์ชันสำหรับแสดงข้อความแจ้งเตือนโดยใช้ Ant Design notification
 * @param {('success'|'error'|'warning'|'info')} type - ประเภทของ Toast (ใช้แทน icon)
 * @param {string} msg - หัวข้อหลักของข้อความแจ้งเตือน
 * @param {string} description - รายละเอียดของข้อความแจ้งเตือน
 * @returns {void}
 */
export const openNotification = (type, msg, description) => {
  notification[type]({
    message: msg,
    description: description,
    showProgress: true,
    pauseOnHover: true,
  });
};
/**
 * ฟังก์ชันสำหรับแสดงข้อความแจ้งเตือนโดยใช้ Ant Design notification
 * @param {('success'|'error'|'warning'|'info')} type - ประเภทของ Toast (ใช้แทน icon)
 * @param {number} duration - หัวข้อหลักของข้อความแจ้งเตือน
 * @param {string} msg - หัวข้อหลักของข้อความแจ้งเตือน
 * @param {string} description - รายละเอียดของข้อความแจ้งเตือน
 * @returns {void}
 */
export const openNotificationDuration = (type, duration, msg, description) => {
  notification[type]({
    message: msg,
    description: description,
    duration: duration || 0,
  });
};
/**
 * @param {string} text
 */
export const removeBackslashes = (text) => {
  //console.error(text);
  if (typeof text !== "string") {
    return "";
  }
  return text.replace(/^\\"/, "").replace(/\\"$/, "");
};
export const NoData = (
  <em style={{ color: "#888" }}>
    <small>{t("No data")}</small>
  </em>
);
/**
 * @param {string} data
 */
export const processPollingStatus = (data) => {
  try {
    if (!data) {
      return;
    }
    const parsedData = JSON.parse(data?.latestPollingStatus);
    let status = JSON.parse(parsedData);

    return status?.status?.code;
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }
};

/**
 * @param {string} a
 * @param {string} b
 */
export const accountTypeSorter = (a, b) => {
  if (a.accountType === "deposit" && b.accountType !== "deposit") {
    return -1;
  }
  if (a.accountType !== "deposit" && b.accountType === "deposit") {
    return 1;
  }
  if (a.accountType && b.accountType) {
    return a.accountType.localeCompare(b.accountType);
  }
  return 0;
};

export const resourceSections = [
  { title: "สถานะบัญชี", type: "Dashboard" },
  { title: "ลูกค้า", type: "Customer" },
  { title: "Deposits", type: "Deposit" },
  { title: "Withdrawals menu", type: "Withdraw" },
  { title: "Bank Account", type: "BankAccount" },
  { title: "User", type: "User" },
  { title: "ตรวจสอบสลิป", type: "CheckSlip" },
  { title: "Merchants", type: "Merchant" },
  { title: "Report", type: "Report" },
  { title: "BuyCredit", type: "BuyCredit" },
  { title: "Setting", type: "Setting" },
  { title: "ApiDocumentation", type: "ApiDocumentation" },
  { title: "Ticket", type: "Ticket" },
];


/** * ฟังก์ชันสำหรับตรวจสอบสิทธิ์การเข้าถึงจากข้อมูล permissions ทั้งหมด
 * @param {Array} permissions - รายการ permissions ทั้งหมดของผู้ใช้
 * @param {string} targetAction - ชื่อ action ที่ต้องการเช็ค เช่น 'edit', 'add', 'details'
 * @returns {boolean}
 */
export const hasPermission = (permissions, targetAction) => {
  if (!Array.isArray(permissions) || !targetAction) return false;

  // วนลูปหาในทุกๆ permission object
  return permissions.some(item => {
    try {
      // Parse string JSON จากฟิลด์ flatpermission
      const flat = JSON.parse(item.flatpermission || "{}");
      // เช็คว่าใน accessible array มี targetAction ที่เราต้องการไหม
      return flat.accessible && flat.accessible.includes(targetAction);
    } catch (e) {
      console.error("Error parsing flatpermission:", e);
      return false;
    }
  });
};

// Function สำหรับดาวน์โหลด Excel
export const handleDownloadExcel = (dataForExcel, notification, title = "Sheet1") => {
  let ExcelData = dataForExcel;
  if (!ExcelData) {
    console.log("Data is not an array:", ExcelData);
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(ExcelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, title);
  // กำหนดชื่อไฟล์
  const fileName = `${notification || moment().locale("th").format("ll")}.xlsx`;
  // สร้างและดาวน์โหลดไฟล์
  XLSX.writeFile(workbook, fileName);
};

export const rangePresets = [
  { label: `${t("7 วันที่ผ่านมา")}`, value: [dayjs().add(-7, "d"), dayjs()] },
  { label: `${t("14 วันที่ผ่านมา")}`, value: [dayjs().add(-14, "d"), dayjs()] },
  { label: `${t("30 วันที่ผ่านมา")}`, value: [dayjs().add(-30, "d"), dayjs()] },
  { label: `${t("90 วันที่ผ่านมา")}`, value: [dayjs().add(-90, "d"), dayjs()] },
];
export const customRanges = {
  Today: [new Date(), new Date()],
  Yesterday: [
    new Date(new Date().setDate(new Date().getDate() - 1)),
    new Date(new Date().setDate(new Date().getDate() - 1)),
  ],
  "Last 7 Days": [
    new Date(new Date().setDate(new Date().getDate() - 6)),
    new Date(new Date()),
  ],
  "Last 30 Days": [
    new Date(new Date().setDate(new Date().getDate() - 29)),
    new Date(new Date()),
  ],
  "This Month": [
    new Date(new Date().setDate(1)),
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  ],
  "Last Month": [
    new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
    new Date(new Date().getFullYear(), new Date().getMonth(), 0),
  ],
};

export const startCountdown = (initialSeconds, onTick) => {
  let secondsLeft = initialSeconds;
  // เรียกใช้ฟังก์ชัน onTick ครั้งแรกทันทีเพื่อแสดงค่าเริ่มต้น
  onTick(secondsLeft);

  const intervalId = setInterval(() => {
    secondsLeft -= 1;
    onTick(secondsLeft);

    // ตรวจสอบว่านับถอยหลังเสร็จสิ้นแล้วหรือไม่
    if (secondsLeft <= 0) {
      clearInterval(intervalId);
    }
  }, 1000);

  // ส่งค่า intervalId กลับไปเพื่อให้สามารถยกเลิกได้จากภายนอก

  return intervalId;
};

export const getAverageTime = (created_at, updated_at) => {
  // 1. แปลง timestamp string เป็น object Date
  // ตัวอย่าง created_at มี microsecond ที่ต้องตัดทิ้งก่อน
  const start = new Date(created_at);
  const end = new Date(updated_at);

  // 2. คำนวณหาความแตกต่างของเวลาในหน่วยมิลลิวินาที
  const diffInMilliseconds = end - start;

  // 3. แปลงมิลลิวินาทีเป็น นาที และ วินาที
  const minutes = Math.floor(diffInMilliseconds / 60000); // 1 นาที = 60,000 มิลลิวินาที
  const seconds = Math.floor((diffInMilliseconds % 60000) / 1000); // วินาทีที่เหลือ

  // 4. สร้างและคืนค่า string ตามเงื่อนไข
  if (minutes > 0) {
    return `${minutes} นาที ${seconds} วินาที/รายการ`;
  } else {
    return `${seconds} วินาที/รายการ`;
  }
};

/**
 * ฟังก์ชันสำหรับกรองข้อมูลผู้ใช้ที่สมัครในวันนี้
 * @param {Array<Object>} users - Array ของ object ผู้ใช้
 * @returns {Array<Object>} - Array ของ object ผู้ใช้ที่สมัครในวันนี้
 */
export const getUsersRegisteredToday = (users) => {
  // สร้าง Date object สำหรับวันที่ปัจจุบัน และกำหนดเวลาให้เป็นเที่ยงคืน (00:00:00)
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // กรองผู้ใช้แต่ละคนใน array
  const usersRegisteredToday = users.filter((user) => {
    // แปลงค่า created_at string เป็น Date object
    const createdAtDate = new Date(user.created_at);

    // เปรียบเทียบวันที่สมัครกับวันที่ปัจจุบัน
    return createdAtDate >= today;
  });

  return usersRegisteredToday;
};

export const handleLogout = () => {
  let show = document.getElementById("showBTN");
  let loading = document.getElementById("loadingBTN");
  if (show && loading) {
    show.classList.add("d-none");
    loading.classList.remove("d-none");
  }


  let secondsToGo = 30;
  let timer = null;
  let isCancelled = false;

  const modal = Modal.confirm({
    title: `${t(`ออกจากระบบใน`, { seconds: secondsToGo })}`,
    content: `${t("กด 'ออกจากระบบ' เพื่อดำเนินการทันที หรือ 'ยกเลิก'?")}`,
    okText: `${t("logout")}`,
    style: {
      top: 20,
    },
    cancelText: `${t("cancel")}`,
    onOk: () => {
      clearInterval(timer);
      funLogout();
      if (show && loading) {
        show.classList.remove("d-none");
        loading.classList.add("d-none");
      }
    },
    onCancel: () => {
      isCancelled = true;
      clearInterval(timer);
      if (show && loading) {
        show.classList.remove("d-none");
        loading.classList.add("d-none");
      }
    },
  });

  timer = setInterval(() => {
    secondsToGo -= 1;
    modal.update({
      title: `${t(`ออกจากระบบใน`, { seconds: secondsToGo })}`,
    });
  }, 1000);
  setTimeout(() => {
    clearInterval(timer);
    modal.destroy();
    if (!isCancelled) {
      funLogout();
    }
  }, secondsToGo * 1000);
};

export const DOCTYPerrorMessage = (data) => {
  // HTML string ที่คุณได้รับมา
  let resError = data;
  // 1. สร้าง div element ชั่วคราวในหน่วยความจำ
  const tempElement = document.createElement("div");
  if (!tempElement) {
    return undefined;
  }
  // 2. ใส่ HTML string เข้าไปใน innerHTML
  tempElement.innerHTML = resError;
  // 3. ดึงข้อความจากแท็ก <pre>
  const errorMessage = tempElement.querySelector("pre")?.textContent;
  // 4. แสดงผลข้อความที่ได้
  return errorMessage || undefined;
};

export const Maintanance = () => (
  <Result
    status="warning"
    icon={<ToolOutlined />}
    title="Maintanance."
    subTitle={
      <>
        <article>
          <h1>We’ll be back soon!</h1>
          <div>
            <p>
              ขออภัยในความไม่สะดวก
              <br /> แต่ขณะนี้เรากำลังดำเนินการบำรุงรักษาระบบอยู่.
              <br /> คุณสามารถใช้งานฟังชั่นอื่นๆได้ปกติ
              หากคุณต้องการความช่วยเหลือ <br />
              คุณสามารถติดต่อเราได้ตลอดเวลา ตามช่องทางที่คุณได้รับ!
            </p>
            <p>— The Team Support</p>
          </div>
        </article>
      </>
    }
  />
);

/**
 * ฟังก์ชันสำหรับคำนวณค่าธรรมเนียม
 * @param {number} amount - จำนวนเงินก่อนหักค่าธรรมเนียม
 * @param {number} feeRate - อัตราค่าธรรมเนียม (เช่น 0.2)
 * @returns {number} - จำนวนค่าธรรมเนียมที่คำนวณได้
 */
export const calculateFee = (amount, feeRate) => {
  // ตรวจสอบว่าค่าที่ส่งเข้ามาเป็นตัวเลขและเป็นบวก
  if (
    typeof parseFloat(amount) !== "number" ||
    typeof parseFloat(feeRate) !== "number" ||
    parseFloat(amount) < 0 ||
    parseFloat(feeRate) < 0
  ) {
    console.error(
      "Invalid input. Please provide positive numbers for amount and feeRate.",
    );
    return 0;
  }

  // คำนวณค่าธรรมเนียม
  const fee = (parseFloat(feeRate) / 100) * parseFloat(amount);

  // คืนค่าธรรมเนียม
  return fee;
};

/**
 * ฟังก์ชันสำหรับจัดรูปแบบเบอร์พร้อมเพย์
 * @param {string} promptPayNumber - เบอร์พร้อมเพย์ (10 หรือ 13 หลัก)
 * @returns {string} - เบอร์พร้อมเพย์ที่จัดรูปแบบแล้ว เช่น "02-0566-705-3337"
 */
export const formatPromptPayNumber = (promptPayNumber) => {
  if (
    !promptPayNumber ||
    promptPayNumber === undefined ||
    promptPayNumber.length < 10
  ) {
    return null;
  }
  // ลบอักขระที่ไม่ใช่ตัวเลขออกก่อน
  const cleanedNumber = promptPayNumber?.replace(/\D/g, "");

  // ตรวจสอบความยาวของเบอร์พร้อมเพย์
  if (cleanedNumber.length === 13) {
    // จัดรูปแบบสำหรับเบอร์ 13 หลัก (เลขบัตรประชาชน)
    return `${cleanedNumber.substring(0, 1)} ${cleanedNumber.substring(
      1,
      5,
    )} ${cleanedNumber.substring(5, 10)} ${cleanedNumber.substring(
      10,
      12,
    )} ${cleanedNumber.substring(12, 13)}`;
  } else if (cleanedNumber.length === 10) {
    // จัดรูปแบบสำหรับเบอร์ 10 หลัก (เบอร์โทรศัพท์)
    return `${cleanedNumber.substring(0, 3)} ${cleanedNumber.substring(
      3,
      6,
    )} ${cleanedNumber.substring(6, 10)}`;
  } else if (cleanedNumber.length === 12) {
    // จัดรูปแบบสำหรับเบอร์ 10 หลัก (เบอร์โทรศัพท์)
    return `${cleanedNumber.substring(0, 2)} ${cleanedNumber.substring(
      2,
      6,
    )} ${cleanedNumber.substring(6, 9)} ${cleanedNumber.substring(9, 12)}`;
  } else {
    return promptPayNumber;
  }
};

/**
 * @description Creates or retrieves a user device ID.
 * @returns {string} The user's device ID.
 */
export const generateDeviceId = () => {
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length.toString();
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  uid += navigator_info.plugins.length;
  uid += screen_info.height || "";
  uid += screen_info.width || "";
  uid += screen_info.pixelDepth || "";
  return uid;
};

/**
 * @description Generates a random alphanumeric string of a specific length.
 * @returns {string} The generated random string.
 */
export const generateRandomString = () => {
  // Define all possible characters
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const length = 5;

  // Loop to pick 5 random characters
  for (let i = 0; i < length; i++) {
    // Get a random index from the 'characters' string
    const randomIndex = Math.floor(Math.random() * characters.length);

    // Append the character at the random index to our result
    result += characters.charAt(randomIndex);
  }

  return result;
};

/**
 * @description Generates a random password with a specified length range and character requirements.
 * @returns {string} The generated password.
 */
export const generatePassword = () => {
  const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
  const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numberChars = "0123456789";
  const allChars = lowercaseChars + uppercaseChars + numberChars;

  // Generate a random length between 8 and 15
  const passwordLength = Math.floor(Math.random() * (15 - 8 + 1)) + 8;

  let password = "";

  // Ensure at least one uppercase letter
  password += uppercaseChars.charAt(
    Math.floor(Math.random() * uppercaseChars.length),
  );

  // Ensure at least one number
  password += numberChars.charAt(
    Math.floor(Math.random() * numberChars.length),
  );

  // Fill the rest of the password with random characters
  for (let i = 2; i < passwordLength; i++) {
    password += allChars.charAt(Math.floor(Math.random() * allChars.length));
  }

  // Shuffle the password to randomize the position of uppercase and number
  password = password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return password;
};

export const defaultDataRoleOwner = [
  1, 2, 3, 7, 12, 13, 15, 16, 17, 18, 19, 21, 22, 23, 24, 25, 27, 28,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
  49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,
  66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77
];

/**
 * ฟังก์ชันสำหรับดึงข้อมูล Role IDs เริ่มต้นของ Owner
 * โดยกรองเฉพาะรายการที่ attributes เป็น "*" และ ispublic เป็น true
 * * @param {Array} arrData - ข้อมูลสิทธิ์ทั้งหมด
 * @returns {number[]} รายการ ID ทั้งหมดที่ผ่านเงื่อนไข
 */
export const getDefaultDataRoleOwner = (arrData) => {
  // ตรวจสอบก่อนว่า arrData เป็น Array หรือไม่ เพื่อป้องกัน Error
  if (!Array.isArray(arrData)) return [];

  return arrData
    .filter((item) => item.attributes === "*" && item.ispublic === true) // ขั้นตอนการกรองเงื่อนไข
    .map((item) => item.id); // ขั้นตอนการดึงเอาเฉพาะค่า id
};
/**
 * ฟังก์ชันสำหรับดึงข้อมูล Role IDs เริ่มต้นของ Owner
 * โดยกรองเฉพาะรายการที่ attributes เป็น "*" และ ispublic เป็น true
 * * @param {Array} arrData - ข้อมูลสิทธิ์ทั้งหมด
 * @returns {number[]} รายการ ID ทั้งหมดที่ผ่านเงื่อนไข
 */
export const getSpecialDataRoleOwner = (arrData) => {
  // ตรวจสอบก่อนว่า arrData เป็น Array หรือไม่ เพื่อป้องกัน Error
  if (!Array.isArray(arrData)) return [];

  return arrData
    .filter((item) => (item.attributes === "*" || item.attributes === "special") && item.ispublic === true) // ขั้นตอนการกรองเงื่อนไข
    .map((item) => item.id); // ขั้นตอนการดึงเอาเฉพาะค่า id
};
export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent,
  );
};

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1) {
    return "Google Chrome";
  }
  if (userAgent.indexOf("Edg") > -1) {
    return "Microsoft Edge";
  }
  if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  }
  if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
    return "Safari";
  }
  if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    return "Opera";
  }
  return "กำลังใช้งาน";
};
export const getOS = () => {
  const userAgent = navigator.userAgent;
  let os = "Unknown"; // กำหนดค่าเริ่มต้นเป็น "Unknown"
  let icon = "";
  // เช็ค iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    os = "iOS";
    icon = <AppleOutlined style={{ fontSize: 12 }} />;
  }
  // เช็ค Android
  else if (/Android/.test(userAgent)) {
    os = "Android";
    icon = <AndroidOutlined style={{ fontSize: 12 }} />;
  }
  // เช็ค Windows Phone
  else if (/Windows Phone|iemobile|WPDesktop/.test(userAgent)) {
    os = "Windows Phone";
    icon = <WindowsOutlined style={{ fontSize: 12 }} />;
  }
  // เช็ค macOS
  else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    os = "macOS";
    icon = <AppleOutlined style={{ fontSize: 12 }} />;
  }
  // เช็ค Windows OS
  else if (/Win(dows|16|32|64|95|98|NT)/.test(userAgent)) {
    os = "Windows";
    icon = <WindowsOutlined style={{ fontSize: 12 }} />;
  }
  // เช็ค Linux
  else if (/Linux/.test(userAgent)) {
    os = "Linux";
    icon = <LinuxOutlined style={{ fontSize: 12 }} />;
  }

  return {
    os,
    icon,
  };
};

/**
 *
 * @param {string} url - สตริง URL ที่ต้องการประมวลผล
 * @returns {string} - สตริงที่ไม่มี "http://" หรือ "https://"
 */
export const removeProtocol = (url) => {
  if (typeof url !== "string" || url.length === 0) {
    return "";
  }
  const regex = /^(https?:\/\/)/;
  return url.replace(regex, "");
};

/**
 * ฟังก์ชันสำหรับแปลงข้อความเป็นเสียงพูดโดยใช้ Web Speech API.
 * @param {string} notification - ข้อความที่ต้องการให้ AI อ่าน.
 * @param {object} options - ออบเจกต์สำหรับกำหนดคุณสมบัติการอ่าน (ทางเลือก).
 * @param {number} [options.rate=1] - อัตราความเร็วในการอ่าน (ค่าเริ่มต้น 1).
 * @param {number} [options.pitch=1] - ระดับเสียง (ค่าเริ่มต้น 1).
 */
export const speak = (notification, options = {}) => {
  // ตรวจสอบว่าเบราว์เซอร์รองรับ Speech Synthesis API หรือไม่
  if ("speechSynthesis" in window) {
    const speech = new SpeechSynthesisUtterance(notification);

    // กำหนดคุณสมบัติตาม options ที่ส่งเข้ามา
    // speech.rate = options.rate || 1;
    // speech.pitch = options.pitch || 1;
    speech.rate = 1;
    speech.pitch = 1;

    // สามารถเลือกเสียงที่ต้องการได้ หากมีหลายภาษา
    const voices = window.speechSynthesis.getVoices();
    console.log(voices);
    // speech.voice = voices[0]; // เลือกเสียงแรกในรายการ

    // อ่านออกเสียง
    window.speechSynthesis.speak(speech);
  } else {
    openNotification(
      "error",
      "error",
      "Web Speech API ไม่รองรับบนเบราว์เซอร์นี้",
    );
  }
};

export const scheduleDailyCleanup = () => {
  const now = new Date();
  const midnight = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1, // ตั้งค่าเป็นวันถัดไป
    0, // ชั่วโมง
    0, // นาที
    0, // วินาที
  );
  // คำนวณเวลาที่เหลือจนถึงเที่ยงคืน
  const msUntilMidnight = midnight.getTime() - now.getTime();
  setTimeout(() => {
    localStorage.removeItem("viewedNotifyIds");
    console.log("localStorage for viewedNotifyIds cleared.");
    scheduleDailyCleanup();
  }, msUntilMidnight);
};

/**
 * @param {string|number} err - โค้ดข้อผิดพลาดที่ต้องการตรวจสอบ
 * @param {string| undefined} fun - ชื่อฟังก์ชันที่เกิดข้อผิดพลาด
 * @returns {string} - คืนค่าข้อความ Error ที่จัดรูปแบบแล้ว
 */
export const errorCode = (err, fun) => {
  // แปลงค่าให้เป็น Number เพื่อความแม่นยำในการดึง Key จาก Object
  const statusCode = Number(err);
  const pageInfo = `func: ${fun}`;

  const errorMessages = {
    400: "คำขอไม่ถูกต้อง (Bad Request)",
    402: "Payment Required",
    403: "ถูกปฏิเสธการเข้าถึง (Forbidden)",
    404: "ไม่พบ Page API ที่ต้องการ (Not Found)",
    405: "ไม่รองรับเมธอด (Method Not Allowed)",
    406: "ไม่สามารถยอมรับได้ (Not Acceptable)",
    407: "ต้องมีการยืนยันตัวตนผ่านพร็อกซี (Proxy Authentication Required)",
    408: "หมดเวลาการร้องขอ (Request Timeout)",
    409: "การร้องขอขัดแย้งกัน (Conflict)",
    410: "ไม่พร้อมใช้งานอีกต่อไป (Gone)",
    411: "ต้องระบุความยาว (Length Required)",
    412: "ข้อกำหนดเบื้องต้นล้มเหลว (Precondition Failed)",
    413: "เพย์โหลดใหญ่เกินไป (Payload Too Large)",
    414: "URI ยาวเกินไป (URI Too Long)",
    415: "ไม่รองรับประเภทสื่อ (Unsupported Media Type)",
    416: "ช่วงไม่เป็นที่พอใจ (Range Not Satisfiable)",
    417: "คาดหวังล้มเหลว (Expectation Failed)",
    418: "ฉันเป็นกาต้มน้ำ (I'm a teapot)",
    421: "คำขอถูกเปลี่ยนเส้นทางอย่างไม่ถูกต้อง (Misdirected Request)",
    422: "หน่วยงานที่ไม่สามารถประมวลผลได้ (Unprocessable Entity)",
    423: "ถูกล็อก (Locked)",
    424: "การพึ่งพาล้มเหลว (Failed Dependency)",
    425: "เร็วเกินไป (Too Early)",
    426: "ต้องมีการอัปเกรด (Upgrade Required)",
    428: "ต้องมีข้อกำหนดเบื้องต้น (Precondition Required)",
    429: "คำขอมากเกินไป (Too Many Requests)",
    431: "ฟิลด์หัวข้อคำขอใหญ่เกินไป (Request Header Fields Too Large)",
    451: "ไม่พร้อมใช้งานด้วยเหตุผลทางกฎหมาย (Unavailable For Legal Reasons)",
    500: "ข้อผิดพลาดจากเซิร์ฟเวอร์ (Internal Server Error)",
    501: "ไม่ได้นำไปใช้ (Not Implemented)",
    502: "เกตเวย์ไม่ถูกต้อง (Bad Gateway)",
    503: "เซิร์ฟเวอร์ไม่พร้อมใช้งาน (Service Unavailable)",
    504: "หมดเวลาเกตเวย์ (Gateway Timeout)",
    505: "ไม่รองรับเวอร์ชัน HTTP (HTTP Version Not Supported)",
    506: "ตัวเลือกโปร่งใส (Variant Also Negotiates)",
    507: "พื้นที่จัดเก็บไม่เพียงพอ (Insufficient Storage)",
    508: "ตรวจพบ Loop (Loop Detected)",
    510: "ไม่ได้ขยาย (Not Extended)",
    511: "ต้องมีการยืนยันตัวตนเครือข่าย (Network Authentication Required)",
    522: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ภายในเวลาที่กำหนด (Connection Timed Out)",
  };
  // 1. จัดการกรณี 401 (Unauthorized)

  if (statusCode === 401) {
    Swal.fire({
      title: `Status code: ${statusCode}`,
      text: "Unauthorized",
      icon: "error",
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: t("logout"),
      cancelButtonColor: "#d33",
    })
      .then((result) => {
        if (result.isConfirmed || result.isDismissed) logout();
      })
      .catch((swalErr) => console.error(`Swal Error: ${swalErr} ${pageInfo}`));

    return `${statusCode} Unauthorized`;
  }

  // 1.1 กรณีพิเศษ status 200 ok
  if (statusCode === 200) {
    return `🟢 ${statusCode} ${`ok`}`;
  }
  // 1.2 กรณีพิเศษ status 201 Created
  if (statusCode === 201) {
    return `🟢 ${statusCode} ${`Created`}`;
  }
  // 1.3 กรณีพิเศษ status อื่นๆ
  if (statusCode >= 202 && statusCode < 300) {
    return `🟢 ${statusCode}`;
  }
  // 2. ค้นหาข้อความ Error
  const message = errorMessages[statusCode] || "ข้อผิดพลาดที่ไม่รู้จัก (Unknown Error)";

  const formatStatusCode = `🔴 ${statusCode} ${message}`;

  // 3. แสดง Notification เฉพาะกรณีที่มีในรายการที่กำหนดไว้
  // if (errorMessages[statusCode]) {
  //   return errorMessages[statusCode]
  // }

  return formatStatusCode;
};

/**
 * @param {string|number} value - โค้ดข้อผิดพลาดที่ต้องการตรวจสอบ
 * @returns {string}
 */
export const formatAccountNumber = (value) => {
  // ลบอักขระที่ไม่ใช่ตัวเลขออกก่อน
  const numericValue = value.replace(/\D/g, "");
  // ใช้ RegEx เพื่อจัดรูปแบบเป็น XXX-XXX-XXXX
  return numericValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3").slice(0, 12);
};

/**
 * ฟังก์ชันสำหรับแปลงเลขบัญชีให้เป็นรูปแบบที่กำหนด
 * เช่น "1234567890" จะกลายเป็น "XXX-X-XX789-0"
 * @param {string} accountNumber - เลขบัญชีในรูปแบบสตริง
 * @returns {string} - เลขบัญชีที่ถูกจัดรูปแบบแล้ว หรือข้อความแจ้งเตือนหากไม่ถูกต้อง
 */
export const formatAccnumID = (accountNumber) => {
  // ตรวจสอบว่าพารามิเตอร์เป็นสตริงและมีความยาวที่เหมาะสม
  if (typeof accountNumber !== "string" || accountNumber.length < 10) {
    return "Invalid account number provided.";
  }

  // ใช้การเชื่อมสตริงเพื่อสร้างรูปแบบใหม่
  const formattedNumber =
    `XXX` + // 3 หลักแรก
    `-` +
    `X` + // หลักที่ 5
    `-` +
    `XX` + // หลักที่ 7 และ 8
    `${accountNumber.slice(6, 9)}` + // 3 หลักถัดไป (031)
    `-` +
    `${accountNumber.slice(9)}`; // หลักสุดท้าย (8)

  return formattedNumber;
};

/**
 * ฟังก์ชันสำหรับลบคำนำหน้าชื่อออกจากชื่อเต็ม
 * @param {string} fullName - ชื่อเต็มที่มีคำนำหน้า (เช่น "นาย John Doe")
 * @returns {string} - ชื่อเต็มที่ไม่มีคำนำหน้า
 */
const removeTitleName = (fullName) => {
  if (typeof fullName !== "string" || !fullName) {
    return fullName;
  }
  const prefixes = [
    "นาย ",
    "นาย",
    "นางสาว",
    "นาง ",
    "น.ส.",
    "น.ส. ",
    "Mr. ",
    "Mr.",
    "Mrs. ",
    "Mrs.",
    "Ms. ",
    "Ms.",
    "Dr. ",
    "Dr.",
  ];
  for (const prefix of prefixes) {
    if (fullName.startsWith(prefix)) {
      return fullName.slice(prefix.length).trim();
    }
  }
  return fullName;
};

/**
 * ฟังก์ชันสำหรับจัดรูปแบบชื่อที่นิยมใช้ในปัจจุบัน
 * @param {string} name - ชื่อเต็มที่มีหรือไม่มีคำนำหน้าก็ได้
 * @returns {string} - ชื่อที่ถูกจัดรูปแบบแล้ว
 */
export const formatName = (name) => {
  if (!name) return;
  // 1. ลบคำนำหน้าชื่อออกก่อน
  const nameWithoutTitle = removeTitleName(name);

  // 2. แยกชื่อและนามสกุล
  const parts = nameWithoutTitle.split(/\s+/);

  // ตรวจสอบว่ามีอย่างน้อย 2 ส่วน (ชื่อและนามสกุล)
  if (parts.length < 2) {
    return nameWithoutTitle;
  }

  const firstName = parts[0];
  const lastName = parts[parts.length - 1];
  return `${firstName} ${lastName.charAt(0)}*****`;
};
/**
 * ฟังก์ชันสำหรับจัดรูปแบบชื่อร้านค้าให้แสดงเพียงตัวอักษรแรกและตามด้วยเครื่องหมายดอกจัน
 * @param {string} merchantName - ชื่อร้านค้าเต็ม (เช่น "Mandalay")
 * @returns {string} - ชื่อที่ถูกจัดรูปแบบแล้ว (เช่น "M*****")
 */
export const formatMerchantName = (merchantName) => {
  // 1. ตรวจสอบว่าชื่อร้านค้าเป็นสตริงและมีความยาวที่เหมาะสม
  if (typeof merchantName !== "string" || merchantName.length === 0) {
    return ""; // คืนค่าสตริงว่างหากไม่มีข้อมูล
  }

  // 2. ดึงตัวอักษรตัวแรกของชื่อร้านค้า
  const firstLetter = merchantName.charAt(0);

  // 3. สร้างสตริงที่มีเครื่องหมายดอกจัน (*) ตามความยาวที่เหลือ
  // ถ้าชื่อยาว "Mandalay" (8 ตัว) ส่วนที่เหลือคือ 7 ตัว
  const remainingLength = merchantName.length - 1;
  const asterisks = "*".repeat(remainingLength);

  // 4. นำตัวอักษรตัวแรกกับดอกจันมารวมกันแล้วคืนค่า
  return `${firstLetter}${asterisks}`;
};

/**
 * @param {Object} userInfo
 * @param {Object} roleName
 * @returns {string}
 */
export const getRoleDisplayName = (userInfo, roleName) => {
  if (!userInfo && !roleName) {
    return "";
  }
  if (userInfo?.username === "finance-88" && userInfo?.role === "Subowner") {
    return "Cs ( Auditor )";
  }
  if (userInfo?.role === "Subowner" && userInfo?.username !== "Subowner") {
    return "SuperOwner";
  }
  return roleName;
};

/**
 * @param {string} inputString - สตริงช่วงวันที่ เช่น "เริ่มจากวันที่ 2025-09-01 00:00 ถึง 2025-09-01 23:59"
 * @returns {string} สตริงที่ถูกตัดแล้ว เช่น "2025-09-01 2025-09-01"
 */
export const extractDates = (inputString) => {
  if (!inputString) {
    return null;
  }

  const regex = /เริ่มจากวันที่\s*|\s*00:00\s*ถึง\s*|\s*23:59$/g;

  const cleanedString = inputString.replace(regex, " ");

  const dateParts = cleanedString.trim().split(/\s+/);

  if (dateParts.length !== 2) {
    console.error("รูปแบบสตริงอินพุตไม่ถูกต้องหรือไม่พบวันที่สองส่วน");
    return null;
  }
  const [startDate] = dateParts;

  return `${startDate}`;
};

export const scrollToAntSpinContainer = () => {
  const targetElement = document.querySelector(".ant-table-thead");

  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  } else {
    console.log('ไม่พบ Element ที่มี className "ant-table-tbody"');
  }
};

// ฟังก์ชันช่วยจัดรูปแบบตัวเลข (นำมาจาก DetailRow เดิม)
export const formatAmountValue = (val, label, t) => {
  if (val === null || val === undefined) return "-";
  const num = parseFloat(val);
  if (isNaN(num)) return val;
  let isLabelTag = [
    "Tarnsfer Amt.",
    "deduction credit",
    "deduction credit",
    "Amount",
    "Fee",
  ];

  let formatted;

  if (isLabelTag.includes(t(label))) {
    formatted = Intl.NumberFormat().format(num.toFixed(2));
  } else {
    formatted = Intl.NumberFormat().format(num.toFixed(2));
  }
  return `${formatted}.-`;
};

// icon Bank
export const iconBank = (val) => {
  if (val === null || val === undefined) return null;
  let formatted = BankData?.find(
    (item) => item.bank_id === val || item.bank_id === val,
  );
  if (!formatted) {
    return null;
  }
  return formatted?.bankLogo;
};

/**
 *
 * @param {string} bankCode
 * @returns {string}
 */
export const formatLogoBankByBankCode = (bankCode) => {
  if (bankCode === null || bankCode === undefined) return null;
  let formatted = BankData?.find((item) => item.bankCode === bankCode);
  if (!formatted) {
    return null;
  }
  return formatted;
};
// ฟังก์ชันสำหรับเรนเดอร์ Value พร้อมปุ่มคัดลอก/Tag
export const renderValue = (label, value, isAmount, t, onCopy) => {
  let isLabelTag = ["Type", "Status"];
  let isLabelAccount = ["Bank"];
  let bankCode = value === "kkp" ? "KKP" : value;
  let valueType = value === "withdraw" ? "Withdraw" : value;
  let logoURL = iconBank(bankCode);
  let displayValue;
  if (isLabelTag.includes(label)) {
    displayValue = (
      <Tag
        icon={getIcon(value)}
        style={{ fontSize: "14px" }}
        color={tagsBageStatus(value)}
      >
        {t(valueType) || "-"}
      </Tag>
    );
  } else if (isAmount) {
    displayValue = formatAmountValue(value, label, t);
  } else if (isLabelAccount.includes(label)) {
    displayValue = (
      <>
        {logoURL ? (
          <>
            <Avatar size={"small"} src={iconBank(bankCode)} /> -
          </>
        ) : (
          ""
        )}{" "}
        {t(value)}
      </>
    );
  } else {
    displayValue = value || "-";
  }

  const CopyIcon = onCopy ? (
    <CopyOutlined
      onClick={() => onCopy(value)}
      style={{
        cursor: "pointer",
        marginLeft: "8px", // ปรับระยะห่างให้ดูดีขึ้น
        color: "#1890ff",
      }}
      title={t("คัดลอก")}
    />
  ) : null;

  return (
    <span>
      {displayValue}
      {CopyIcon}
    </span>
  );
};

//
/**
 * จัดรูปแบบข้อความบันทึก (note) ตามสถานะ (status)
 *
 * @param {string} note - ข้อความบันทึกเดิม
 * @param {string} status - สถานะของการทำรายการ (เช่น "SUCCESS", "IN_QUEUE")
 * @returns {string} ข้อความบันทึกที่จัดรูปแบบแล้ว หรือ "-" หากสถานะไม่ตรงกับที่กำหนด
 */
export const formatNote = (note, status) => {
  const isDefaultNote = note === "Withdrawal request";
  let formattedText = note; // กำหนดค่าเริ่มต้นเป็น note เดิม

  // กำหนดข้อความเฉพาะสำหรับสถานะต่างๆ เมื่อ note เป็นค่าเริ่มต้น
  if (isDefaultNote) {
    switch (status) {
      case "SUCCESS":
        formattedText = "Transaction successful...";
        break;
      case "IN_QUEUE":
        formattedText = "อยู่ในคิวดำเนินการ...";
        break;
      case "INQ_MANUAL":
        formattedText = "อยู่ในคิวดำเนินการ ถอนมือ...";
        break;
      case "VERRIFY_FAILED":
        formattedText = "เกิดข้อผิดพลาดระหว่างเชื่อมต่อธนาคาร...";
        break;
      case "PROCESSING":
        formattedText = "อยู่ระหว่างตรวจสอบรายการ...";
        break;
      case "PENDING":
        formattedText = "กำลังรอการประมวลผล...";
        break;
      case "REJECTED":
        formattedText = "Transaction  Rejected...";
        break;
      default:
        // ถ้าสถานะไม่ตรงกับ case ใดๆ จะคืนค่า "-"
        return "-";
    }
  }

  return formattedText;
};

/**
 * แสดงกล่องโต้ตอบการยืนยันโดยใช้ SweetAlert2
 *
 * @param {('warning'|'error'|'success'|'info'|'question')} type - ประเภทของไอคอน
 * @param {string} msg - ข้อความที่ต้องการให้แสดงในกล่องโต้ตอบ
 * @param {string} footer - ข้อความด้านล่างของกล่องโต้ตอบ (footer)
 * @returns {Promise<boolean>} Promise ที่จะ Resolve ด้วย true หากผู้ใช้กด "Confirm"
 * และ Resolve ด้วย false หากผู้ใช้กด "Cancel" หรือปิดกล่อง
 */
export const confirmSwal = async (type, msg, footer) => {
  // ฟังก์ชันจะคืนค่า Promise ที่ได้จาก Swal.fire() โดยตรง
  return Swal.fire({
    title: t("Are you sure?"),
    text: msg,
    icon: type,
    footer: footer ? `<span style="color: red; font-size: 14px">${t(footer)}</span>` : undefined,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: t("Confirm"),
    cancelButtonText: t("Cancel"),
  }).then((result) => {
    // คืนค่า Boolean จาก Promise
    return result.isConfirmed; // คืนค่า true หากกด Confirm, false หากเป็นอย่างอื่น
  });
};

/**
 * แสดงกล่องโต้ตอบการยืนยันพร้อมช่องกรอกข้อความ (SweetAlert2)
 *
 * @param {('warning'|'error'|'success'|'info'|'question')} type - ประเภทของไอคอน
 * @param {string} msg - ข้อความหัวข้อ
 * @param {string} text - รายละเอียด
 * @param {string} placeholder - ข้อความในช่อง Input (ถ้ามี)
 * @returns {Promise<{isConfirmed: boolean, value: string|null}>}
 */
export const SwalInputConfirm = async (
  type,
  msg,
  text,
  placeholder = "",
) => {
  return Swal.fire({
    title: msg,
    icon: type,
    text: text,
    input: "text",
    inputPlaceholder: placeholder,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: t("Confirm"),
    cancelButtonText: t("Cancel"),
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: (value) => {
      // ตรวจสอบว่ามีการกรอกข้อมูลหรือไม่
      if (!value || value.trim() === "") {
        Swal.showValidationMessage(t("Please enter a note"));
        return false; // ป้องกันไม่ให้ปิดหน้าต่าง
      }
      return value; // ส่งค่าออกไปที่ result.value
    },
  }).then((result) => {
    // ส่งกลับทั้งสถานะการกดยืนยัน และค่าที่พิมพ์มา
    return {
      isConfirmed: result.isConfirmed,
      value: result.isConfirmed ? result.value : null,
    };
  });
};

/**
 * คำนวณขนาดไฟล์เป็น ไบต์ (B), กิโลไบต์ (KB), และ เมกะไบต์ (MB)
 * @param {File} file - ออบเจกต์ไฟล์ที่ต้องการตรวจสอบขนาด
 * @returns {object} ออบเจกต์ที่มีขนาดไฟล์ในหน่วยต่างๆ
 */
export const getFileSizeInfo = (file) => {
  // ขนาดไฟล์เริ่มต้นเป็น ไบต์ (Bytes)
  const bytes = file.size;

  // คำนวณเป็น กิโลไบต์ (Kilobytes)
  // 1 KB = 1024 Bytes
  const kilobytes = bytes / 1024;

  // คำนวณเป็น เมกะไบต์ (Megabytes)
  // 1 MB = 1024 KB = 1024 * 1024 Bytes
  const megabytes = bytes / 1024 / 1024;

  return {
    bytes: bytes,
    kilobytes: kilobytes.toFixed(2), // ปัดเศษให้เหลือทศนิยม 2 ตำแหน่งสำหรับ KB
    megabytes: megabytes.toFixed(2), // ปัดเศษให้เหลือทศนิยม 2 ตำแหน่งสำหรับ MB
  };
};


/**
 * แสดงกล่องโต้ตอบ SweetAlert2 เพื่อรับเหตุผลการยกเลิก/ปฏิเสธ (Note)
 *
 * @param {('warning'|'error'|'success'|'info'|'question')} type - ประเภทของไอคอนที่จะแสดงบน Popup
 * @param {string} msg - ข้อความหัวเรื่อง (Title) ของกล่องโต้ตอบ
 * @param {string | boolean} [footer=false] - ข้อความหมายเหตุเพิ่มเติมด้านล่าง หรือ false หากไม่ต้องการแสดง
 * @returns {Promise<{status: boolean, note: string | null}>} Promise ที่คืนค่าเป็น Object
 * - status: true หากผู้ใช้กดกดปุ่มยืนยัน, false หากผู้ใช้กด ยกเลิก หรือปิดหน้าต่าง
 * - note: ข้อความเหตุผลที่ผู้ใช้กรอก หรือระบุไว้ (string) หาก status เป็น true, และ null หาก status เป็น false
 */
export const rejectedManualSwal = async (type, msg, footer = false) => {
  try {
    // 1. กำหนดค่าเริ่มต้นและตัวเลือกของ SweetAlert2
    const hasFooter = Boolean(footer);

    const result = await Swal.fire({
      title: msg,
      icon: type,
      // หากมี footer จะไม่เปิดให้กรอก textarea แต่จะใช้ค่า default
      input: hasFooter ? undefined : "textarea",
      inputPlaceholder: t("กรุณาระบุเหตุผล..."),
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
      inputValue: hasFooter ? t("ลูกค้าแจ้งไม่ได้รับเงิน") : "",
      footer: hasFooter
        ? `<span style="color: red; font-size: 14px">*${t(String(footer))}</span>`
        : undefined,
      customClass: {
        input: "small-swal-textarea",
        title: "fs-25",
      },
      // ตรวจสอบความถูกต้องของการกรอกข้อมูล (กรณีใช้ textarea)
      inputValidator: (value) => {
        if (!hasFooter && (!value || !value.trim())) {
          return t("กรุณากรอกเหตุผลบางอย่างก่อน");
        }
      },
    });

    // 2. ตรวจสอบผลลัพธ์จากการตอบรับของผู้ใช้งาน
    if (result.isConfirmed) {
      // ดึงค่า note จาก textarea หรือใช้ค่า default กรณีมี footer
      const noteValue = hasFooter ? t("ลูกค้าแจ้งไม่ได้รับเงิน") : result.value ? result.value.trim() : "";
      return {
        status: true,
        note: noteValue
      };
    }

    // กรณีผู้ใช้กด Cancel หรือปิด Popup
    message.info({
      content: t("ยกเลิกการกระทำแล้ว ไม่มีการเปลี่ยนแปลงใดๆ"),
      duration: 4.5,
    });

    return {
      status: false,
      note: null
    };

  } catch (error) {
    console.error("Error in rejectedManualSwal:", error);
    return {
      status: false,
      note: null
    };
  }
};

export const ticketIcon = (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-ticket-detailed-fill"
      viewBox="0 0 16 16"
    >
      <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6zm4 1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5m0 5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5M4 8a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1" />
    </svg>
  </>
);

/**
 * แปลงมิลลิวินาที (ms) เป็นชั่วโมง, นาที, และวินาที ในรูปแบบที่มนุษย์อ่านได้
 * @param {number} milliseconds - จำนวนมิลลิวินาทีที่จะแปลง
 * @returns {string} - สตริงที่แสดงเวลาในรูปแบบ 'Xh Ym Zs'
 */
export const convertMsToHumanReadable = (milliseconds) => {
  if (!milliseconds) {
    return null;
  }
  // 1. คำนวณชั่วโมง นาที และวินาที

  // จำนวนมิลลิวินาทีใน 1 ชั่วโมง
  const msInHour = 1000 * 60 * 60;
  // จำนวนชั่วโมงทั้งหมด
  const hours = Math.floor(milliseconds / msInHour);
  // มิลลิวินาทีที่เหลือจากการคำนวณชั่วโมง
  let remainingMs = milliseconds % msInHour;

  // จำนวนมิลลิวินาทีใน 1 นาที
  const msInMinute = 1000 * 60;
  // จำนวนนาทีทั้งหมด
  const minutes = Math.floor(remainingMs / msInMinute);
  // มิลลิวินาทีที่เหลือจากการคำนวณนาที
  remainingMs = remainingMs % msInMinute;

  // จำนวนวินาทีทั้งหมด
  const seconds = Math.floor(remainingMs / 1000);
  // มิลลิวินาทีที่เหลือ (ถ้าต้องการความแม่นยำระดับมิลลิวินาที)
  const remainingMilliseconds = remainingMs % 1000;

  // 2. สร้างสตริงผลลัพธ์

  const parts = [];

  // เพิ่มส่วนชั่วโมง (ถ้ามี)
  if (hours > 0) {
    parts.push(`${hours}h`);
  }

  // เพิ่มส่วนนาที (ถ้ามี หรือถ้ามีชั่วโมงและนาทีเป็น 0)
  if (minutes > 0 || (hours > 0 && minutes === 0)) {
    parts.push(`${minutes}m`);
  }

  // เพิ่มส่วนวินาที (เพิ่มเสมอเพื่อให้มีค่าพื้นฐาน)
  // เราใช้ทศนิยม 2 ตำแหน่งสำหรับวินาทีเพื่อให้แม่นยำ
  const secWithDecimal = seconds + remainingMilliseconds / 1000;

  // หากมีชั่วโมงหรือนาทีแล้ว ให้แสดงวินาทีแบบเต็ม
  if (parts.length > 0) {
    parts.push(`${secWithDecimal.toFixed(2)}s`);
  } else {
    // ถ้าเวลาน้อยกว่า 1 นาที ให้แสดงเป็นวินาทีพร้อมทศนิยมที่เหมาะสม
    // ใช้ toFixed(3) สำหรับความแม่นยำระดับมิลลิวินาที หรือ toFixed(1) ตามตัวอย่าง
    parts.push(`${secWithDecimal.toFixed(2)}s`);
  }

  // รวมส่วนต่างๆ ด้วยการเว้นวรรค
  return parts.join(" ");
};

export const getFormattedTimezone = () => {
  // 1. ดึงค่า offset ออกมาเป็นนาที (เช่น ไทยจะได้ -420)
  const offsetMinutes = new Date().getTimezoneOffset();

  // 2. แปลงนาทีเป็นชั่วโมง (ต้องกลับเครื่องหมายด้วยการคูณ -1)
  const offsetHours = -offsetMinutes / 60;

  // 3. ใส่เครื่องหมาย + กรณีที่เป็นเลขบวก
  const sign = offsetHours >= 0 ? "+" : "";

  // 4. รวมผลลัพธ์เป็นรูปแบบ GMT+X
  return `GMT${sign}${offsetHours}`;
};

/**
 * ฟังก์ชันสำหรับแปลงมิลลิวินาทีเป็นนาที
 * @param {number} ms - จำนวนมิลลิวินาที
 * @returns {number} - จำนวนนาทีที่คำนวณได้
 */

export const convertMsToMinutes = (ms) => {
  if (!ms) return 0;
  const minutes = ms / 60000;
  return minutes;
};
export const NetworkConnection = () => {
  let navigator = window.navigator;
  return navigator?.onLine;
};
export const updateNetworkStatus = (ms) => {
  const isOnline = NetworkConnection();
  const statusElement = document.getElementById("networkStatus");

  if (statusElement) {
    statusElement.title = isOnline ? t("online") : t("offline");
    statusElement.className = `rounded-circle user-photo hover-user-${isOnline ? t("online") : t("offline")}`;
    statusElement.style.border = isOnline
      ? "2px solid #10b981"
      : "2px solid #c72020";
    statusElement.style.filter = isOnline ? "grayscale(0)" : "grayscale(0.5)";
  }
};

export const updateNetwork = (ms) => {
  const isOnline = NetworkConnection();
  const statusElement = document.getElementById("networks");

  if (statusElement) {
    statusElement.textContent = isOnline ? t("online") : t("offline");
    statusElement.style.color = isOnline ? "#52c41a" : "#c72020";
  }
};

export const generateUserDeviceID = () => {
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length.toString();
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  uid += navigator_info.plugins.length;
  uid += screen_info.height || "";
  uid += screen_info.width || "";
  uid += screen_info.pixelDepth || "";
  return uid;
};

/**
 * ฟังก์ชันสำหรับคำนวณเวลาปัจจุบัน + 1 นาที
 * @param {number} ms - จำนวนมิลลิวินาที
 * @returns {string} วัตถุ Date ที่เพิ่มเวลาแล้ว 1 นาที
 */
export const getNextMinute2 = async (ms) => {
  const timeNow = new Date(sessionStorage.getItem("ext"));
  // 1 นาที = 60 วินาที * 1000 มิลลิวินาที = 60000 ms
  const oneMinuteInMs = ms;
  // สร้างเวลาใหม่โดยเอาเวลาปัจจุบัน (getTime) + 60,000 ms
  const futureTime = new Date(timeNow.getTime() + oneMinuteInMs);
  return t(`Available again at:`, {
    time: moment(futureTime).format("HH:mm:ss"),
  });
};

/**
 * ฟังก์ชันสำหรับคำนวณเวลาถัดไป
 * @param {number} ms - จำนวนมิลลิวินาทีที่จะบวกเพิ่ม
 * @returns {string} ข้อความที่แปลแล้วพร้อมเวลาที่ฟอร์แมตแล้ว
 */
export const getNextMinute = (ms) => {
  // 1. ดึงค่าจาก Storage และตรวจสอบเบื้องต้น
  const storedTime = sessionStorage.getItem("ext");

  // 2. สร้างวัตถุ Date (ถ้าไม่มีค่าใน storage ให้ใช้เวลาปัจจุบันแทนเพื่อป้องกัน Error)
  const timeNow = storedTime ? new Date(storedTime) : new Date();

  // ตรวจสอบว่า Date ที่สร้างมาใช้งานได้จริงหรือไม่ (Invalid Date check)
  if (isNaN(timeNow.getTime())) {
    console.error("Invalid date found in sessionStorage['ext']");
    return "";
  }

  // 3. คำนวณเวลาในอนาคต
  const futureTime = new Date(timeNow.getTime() + ms);

  // 4. ส่งคืนค่าในรูปแบบข้อความที่ฟอร์แมตแล้ว
  // สมมติว่า t คือฟังก์ชัน i18n
  return t(`Available again at:`, {
    time: moment(futureTime).format("HH:mm:ss"),
  });
};

/**
 * แปลงตัวเลขเป็นหน่วย K, M, B แบบมาตรฐาน
 * @param {number|string} value - จำนวนเงินที่ต้องการแปลง
 */
export const formatCurrencyCompact = (value) => {
  if (value === undefined || value === null || value === "") return 0;

  let num = parseFloat(value);
  if (isNaN(num)) return 0;

  // --- ส่วนที่แก้ไข: จัดการเรื่องการปัดลง (Floor) ---
  if (num >= 1000) {
    // เช่น 2581 -> 2.581 -> 25.81 -> floor(25.81) -> 25 -> 2.5
    // วิธีนี้จะคงทศนิยม 1 ตำแหน่งแบบปัดลงเสมอ
    num = Math.floor(num / 100) / 10;
    num = num * 1000; // แปลงกลับเป็นหลักพันเพื่อเข้า Intl.NumberFormat
  }
  // -------------------------------------------

  try {
    return new Intl.NumberFormat("en-US", {
      // ใช้ en-US เพื่อให้ได้ตัวย่อ K, M, B
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }).format(num);
  } catch (error) {
    console.error("formatCurrencyCompact Error:", error);
    return value.toString();
  }
};

/**
 * ค้นหาข้อมูลร้านค้าที่ Active และบันทึกลง LocalStorage หากมีการเปลี่ยนแปลง
 * @param {object} userInfo - ข้อมูลผู้ใช้
 * @param {Array} merchantData - รายการร้านค้า
 * @returns {object|undefined}
 */
export const getActiveMerchantData = (merchantData) => {
  let active_merchantId = localStorage.getItem("selectedID") || 0;
  const activeId = parseInt(active_merchantId);
  // 1. Validation เบื้องต้น
  if (!activeId || !Array.isArray(merchantData)) {
    return undefined;
  }

  // 2. ค้นหาร้านค้า
  const res = merchantData.find((merchant) => merchant.id === activeId);

  // 3. จัดการ LocalStorage (เฉพาะเมื่อพบข้อมูลร้านค้า)
  if (res) {
    const payload = {
      id: res.id,
      name: res.name,
      enabled_verify_hub: res.enabled_verify_hub,
    };

    try {
      const isDataMerchant = getCookie("validateMerchant");
      const currentData = isDataMerchant ? isDataMerchant : null;

      // ตรวจสอบว่า ID เปลี่ยนแปลงไปจากเดิมหรือไม่
      if (!currentData || currentData.id !== res.id) {
        setCookie("validateMerchant", payload);
      }
    } catch (error) {
      console.error("Error handling localStorage:", error);
      // หาก Parse พลาด ให้เขียนทับด้วยข้อมูลใหม่ทันทีเพื่อความปลอดภัย
      getCookie("validateMerchant", payload);
    }
  }

  return res;
};
/**
 * formatCurrency
 * @param {number|string|undefined|null} val - ข้อมูล
 * @returns {number|string}
 */
export const formatCurrency = (val) => {
  return Intl.NumberFormat().format(parseFloat(val || 0).toFixed(2));
};

// --- Helper Functions SendTelegram (เรียกใช้ร่วมกันภายในไฟล์) ---
const escapeHTML = (str) =>
  String(str || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const truncate = (str, max = 3000) =>
  str && str.length > max ? str.substring(0, max) + "... (truncated)" : str;

export const shouldSendTelegram = () => {
  const hostname = window.location.hostname === "localhost";
  const staging = process.env.REACT_APP_ENV === "staging";

  // PROD: !hostname && !staging
  // DEV: hostname && staging
  // STG: !hostname && staging (ไม่ส่ง)
  return (!hostname && !staging) || (hostname && staging);
};

const sendToTelegram = async (text) => {
  try {
    const res = await Api.getApiTelegram(text);
    if (res?.status >= 200 && res?.status < 300) {
      console.log("TNSS");
    } else {
      console.log("TNSE");
    }
  } catch (err) {
    console.error("Critical: Telegram API failed:", err.message);
  }
};
const sendToTelegramSupport = async (text) => {
  try {
    const res = await Api.getApiTelegramSupport(text);
    if (res?.status >= 200 && res?.status < 300) {
      console.log("TNSS");
    } else {
      console.log("TNSE");
    }
  } catch (err) {
    console.error("Critical: Telegram API failed:", err.message);
  }
};
// --- Main Functions ---

/**
 * ดึงข้อความ HTTP Message ที่อ่านรู้เรื่องที่สุดออกมา
 */
export const getHTTPMessage = (error) => {

  if (!error) return "Unknown Error";

  // 1. เช็คข้อมูลจาก Backend (Response Data)
  const serverMessage =
    error?.response?.data?.message?.en ||
    error.response?.data?.message ||
    error?.data?.message;

  // กรณี Backend ส่งมาเป็น Array (มักเจอใน Validation Error)
  if (Array.isArray(serverMessage)) {
    return serverMessage.join(", ");
  }

  // กรณีเป็น String ปกติ
  if (typeof serverMessage === "string") return serverMessage;

  // 2. เช็คจาก Axios/Browser Message
  if (error.message) return error.message;

  return "Unknown Error";
};

/**
 * ดึง HTTP Status Code
 */
export const getHTTPStatus = (error) => {
  // พยายามดึงจาก response status ก่อน ถ้าไม่มีให้เช็ค status code ทั่วไป
  return (
    error?.response?.status ||
    error?.status ||
    (error?.message?.includes("timeout") ? 408 : "Unknown Status")
  );
};

/**
 * 1. ประเภท call api error => ส่งข้อมูลแจ้ง error
 */
export const sendApiTelegram_call_api_error = async (error, page) => {
  const status = getHTTPStatus(error);
  const message = getHTTPMessage(error);
  const stackTrace = error?.stack
    ? error.stack.split("\n").slice(0, 4).join("\n")
    : "No stack trace";

  const isPage = page === "fetchPromiseData";
  let mechant = getValidateMerchant()
  const txt = `
<b>⚠️ ERROR FUNCTION - ${config.web_name_short} ⚠️</b>

<b>Merchant:</b> <code>${mechant.name}</code>   
<b>Provider:</b> <code>${config.web_name}</code>  
<b>Date/Time:</b> <code>${moment().format("YYYY-MM-DD HH:mm:ss")}</code>  
<b>Status Code:</b> <code>${escapeHTML(errorCode(status, page))}</code>
<b>Error Function:</b> <code>${escapeHTML(page)}</code>
<b>Error Message:</b> <code>${escapeHTML(truncate(message, 500))}</code>
${error?.stack ? `\n<b>Stack Trace:</b>\n<pre>${escapeHTML(truncate(stackTrace, 1000))}</pre>` : ""}
${isPage ? `\n<blockquote>* ฟังก์ชัน fetchPromiseData รวบรวม API getRole_permissions, getProfileAdmin และ getRole_menu ไว้ด้วยกัน</blockquote>` : ""}
`;
  if (status === 401) return; // ไม่ส่งแจ้งเตือนสำหรับ Unauthorized (401) เพราะอาจเกิดจาก Token หมดอายุ ซึ่งมีการจัดการอยู่แล้ว
  await sendToTelegram(txt);
};

/**
 * 2. ประเภท activity => ส่งข้อมูลแจ้ง Activity
 */
export const sendApiTelegram_activity = async (
  response,
  activity,
  details,
  admin,
) => {
  const { username, admin_type, merchantId, role } = admin || {};
  const status = getHTTPStatus(response);
  const message = getHTTPMessage(response);

  const isSuccess = status >= 200 && status < 300;

  const txt = `
<b>${isSuccess ? "✅" : "⚠️"} ADMIN ACTIVITY - ${config.web_name_short} ${isSuccess ? "✅" : "⚠️"}</b>

<b>Provider:</b> <code>${config.web_name}</code>
<b>Date/Time:</b> <code>${moment().format("YYYY-MM-DD HH:mm:ss")}</code>
<b>Activity:</b> <code>${escapeHTML(activity)}</code>
<b>Status Code:</b> <code>${escapeHTML(errorCode(status, undefined))}</code>
<b>Message:</b> <code>${escapeHTML(truncate(message, 500))}</code>
<b>Operated By:</b> <code>${escapeHTML(username)}</code>
<b>Role:</b> <code>${escapeHTML(role)}</code>
<b>Admin_type:</b> <code>${escapeHTML(admin_type)}</code>
<b>MerchantID:</b> <code>${merchantId}</code>
<b>Details:</b> <code>${escapeHTML(truncate(details, 500))}</code>
`;

  await sendToTelegram(txt);
};

/**
 * 3. ประเภท activity => ส่งข้อมูลแจ้ง Activity กลุ่ม SUPPORT
 */
export const sendApiTelegram_activity_Support = async (
  response,
  activity,
  details,
  admin,
) => {
  const { username, merchantId, } = admin || {};
  const status = getHTTPStatus(response);
  const { name } = getCookie("validateMerchant") || {};


  const txt = `
<b style="text-transform: uppercase">🔔 ${name} (${merchantId}) - Account Activity</b>

<b>วันที่/เวลา:</b> <code>${moment().format("YYYY-MM-DD HH:mm:ss")}</code>
<b>กิจกรรม:</b> <code>${escapeHTML(truncate(details, 500))}</code>
<b>สถานะ:</b> <code>${escapeHTML(errorCode(status, undefined))}</code>
<b>ผู้ให้บริการ:</b> <code>${config.web_name}</code>

<blockquote>ทำรายการโดย: ${escapeHTML(username)}</blockquote>
`;

  await sendToTelegramSupport(txt);
};

/**
 * 3. ประเภท login => ส่งข้อมูลแจ้ง login
 */
export const sendApiTelegram_login = async (response, page) => {
  const user = response?.data?.user || {};
  const { username, admin_type, merchantId, role } = user;

  const status = getHTTPStatus(response);
  const message = getHTTPMessage(response);
  const isSuccess = status >= 200 && status < 300;

  const txt = `
<b>${isSuccess ? "✅" : "⚠️"} LOGIN ADMIN - ${config.web_name_short} ${isSuccess ? "✅" : "⚠️"}</b>

<b>Provider:</b> <code>${config.web_name}</code>
<b>Date/Time:</b> <code>${moment().format("YYYY-MM-DD HH:mm:ss")}</code>
<b>Activity:</b> <code>${escapeHTML(page)}</code>
<b>Status Code:</b> <code>${escapeHTML(errorCode(status, page))}</code>
<b>Username:</b> <code>${escapeHTML(username)}</code>
<b>Role:</b> <code>${escapeHTML(role)}</code>
<b>Admin_type:</b> <code>${escapeHTML(admin_type)}</code>
<b>MerchantID:</b> <code>${merchantId}</code>
<b>Message:</b> <code>${escapeHTML(message)}</code>
`;

  await sendToTelegram(txt);
};

// --------------------------END------------------

// เช็คว่ามีค่าจริงๆ หรือไม่ (ไม่เอา String ว่าง, null, undefined)
export const isEmpty = (val) => val === "" || val == null;

/**
 * ฟังก์ชันตรวจสอบว่า JWT Token หมดอายุหรือยัง
 * @param {string} token - JWT Token ที่ต้องการเช็ค
 * @returns {boolean} - true ถ้าหมดอายุแล้ว, false ถ้ายังใช้งานได้
 */
export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    // 1. แยกส่วน Payload ออกมา (ส่วนที่ 2 ของ JWT)
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    // 2. ถอดรหัส JSON จาก Base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    const { exp } = JSON.parse(jsonPayload);

    // 3. ตรวจสอบเวลาปัจจุบันเทียบกับค่า exp (หน่วยเป็นวินาที)
    const currentTime = Math.floor(Date.now() / 1000);

    return currentTime >= exp;
  } catch (error) {
    console.error("Invalid token format:", error);
    return true; // ถ้า Token ผิดรูปแบบ ให้ถือว่าหมดอายุ/ใช้งานไม่ได้
  }
};



/**
 * ฟังก์ชันคำนวณระยะเวลาการใช้งานแบบ Friendly Format
 * @param {string} dateString - วันที่เริ่มต้น (ISO String)
 * @returns {string} - ข้อความแสดงระยะเวลา
 */
export const calculateDaysUsed = (dateString) => {
  const start = new Date(dateString);
  const now = new Date();

  // คำนวณส่วนต่างเป็นมิลลิวินาที (ms)
  const diffInMs = now - start;

  // แปลงเป็นหน่วยต่างๆ
  const diffInSecs = Math.floor(diffInMs / 1000);
  const diffInMins = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  // --- Logic การเลือกแสดงผล ---
  // 0. ถ้าไม่ถึง 60 วินาที (น้อยกว่า 60 วินาที)
  if (diffInSecs < 60) {
    return `${Math.max(0, diffInSecs)} ${t("seconds")}`;
  }
  // 1. ถ้าไม่ถึง 1 ชั่วโมง (น้อยกว่า 60 นาที)
  if (diffInMins < 60) {
    return `${Math.max(0, diffInMins)} ${t("minutes")}`;
  }

  // 2. ถ้าไม่ถึง 1 วัน (น้อยกว่า 24 ชั่วโมง)
  if (diffInHours < 24) {
    return `${diffInHours} ${t("hours")}`;
  }

  // 3. ถ้าตั้งแต่ 1 วันขึ้นไป
  return `${diffInDays} ${t("days")}`;
}



/**
 * แปลงหน่วยนาที (Minutes) ให้เป็นข้อความที่อ่านง่าย (เช่น 1h 20m 15s)
 * @param {number|string} minutes - จำนวนนาที
 * @returns {string} - ข้อความแสดงเวลา
 */
export const convertMs = (minutes) => {
  const mins = parseFloat(minutes);
  if (isNaN(mins) || mins <= 0) return "0s";

  // แปลงกลับเป็นวินาทีทั้งหมดเพื่อความแม่นยำในการคำนวณ
  let totalSeconds = Math.floor(mins * 60);

  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minsRemaining = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours} ${t(`hours`)}`);
  if (minsRemaining > 0) parts.push(`${minsRemaining} ${t(`minutes`)}`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds} ${t(`seconds`)}`); // แสดงวินาทีเสมอถ้าไม่มีชั่วโมงและนาที

  return parts.join(" ");
};


/**
 * ฟังก์ชันประเมินระดับบริการจากระยะเวลาเฉลี่ย (นาที)
 */
export const getServiceStatus = (averageMinutes) => {
  if (averageMinutes <= 0) return "N/A";
  if (averageMinutes <= 1) return "Excellent";
  if (averageMinutes <= 3) return "Very Good";
  if (averageMinutes <= 5) return "Good";
  if (averageMinutes <= 10) return "Medium";
  return "Bad";
};

/**
 * ฟังก์ชันคำนวณระยะเวลาเฉลี่ยจากรายการธุรกรรมที่สำเร็จ
 * @param {Array} data - รายการธุรกรรม
 * @returns {number} - ระยะเวลาเฉลี่ยในหน่วยนาที
 */
export const calculateAverageTime = (data) => {
  // 1. Check เบื้องต้นเพื่อป้องกัน Error หาก data ไม่ใช่ Array
  if (!Array.isArray(data) || data.length === 0) {
    return 0;
  }

  // 2. กรองเฉพาะธุรกรรมที่สำเร็จและมีข้อมูลเวลาครบถ้วน
  const successTransactions = data.filter(
    (t) => t.status === "SUCCESS" && t.created_at && t.transactionDateTime
  );

  if (successTransactions.length === 0) {
    return 0;
  }

  // 3. คำนวณผลรวมระยะเวลาทั้งหมด (Milliseconds)
  const totalDurationMs = successTransactions.reduce((sum, transaction) => {
    const start = moment(transaction?.created_at);
    const end = moment(transaction?.transactionDateTime || transaction?.updated_at);
    const duration = end.diff(start);

    // ป้องกันกรณีเวลาติดลบ (ถ้ามี)
    return sum + (duration > 0 ? duration : 0);
  }, 0);

  // 4. คำนวณค่าเฉลี่ยเป็นนาทีเพียงครั้งเดียว
  const avgMs = totalDurationMs / successTransactions.length;
  const avgMinutes = avgMs / (1000 * 60);

  // 5. แสดงผล Status เพื่อ Debug (หรือจะ Return ออกไปพร้อมกันก็ได้)
  // const status = getServiceStatus(avgMinutes);

  let fomatAvgMinutes = convertMs(avgMinutes.toFixed(2));


  return fomatAvgMinutes;
};


/**ฟังก์ชันสำหรับลบ prefix "• " ออกจากข้อความ
 * @param {string} text - ข้อความที่ต้องการลบ prefix
 * @returns {string} - ข้อความที่ถูกลบ prefix แล้ว
 */

export const getRemovePrefix = (text) => {
  if (text.startsWith("• ")) {
    return text.substring(2);
  } else {
    return text;
  }
}


export const UXNodata = () => (<em style={{ color: "rgba(0,0,0,0.25)", fontSize: 11 }}>{t("No data")}</em>)


/**
 * ฟังก์ชันเช็คเฉพาะคำว่า "พบรายการสลิปซ้ำ"
 */
export const splitTransactionRef = (text) => {
  if (!text || typeof text !== "string") {
    return { p1: "", p2: "" };
  }

  // เก็บคำที่ต้องการเช็คไว้ใน Array
  const keywords = ["พบรายการสลิปซ้ำ", "พบรายการฝากเงินซ้ำ"];

  // หาว่าใน text มีคำไหนจากใน keywords บ้าง
  const foundKeyword = keywords.find(k => text.includes(k));

  if (foundKeyword) {
    // ใช้คำที่หาเจอ (foundKeyword) มาเป็นตัวตัดข้อความ
    let remaining = text.replace(foundKeyword, "").trim();

    // ลบวงเล็บออกถ้ามี
    remaining = remaining.replace(/^\(|\)$/g, "");

    return {
      p1: foundKeyword,
      p2: remaining
    };
  }

  // กรณีที่ไม่ตรงกับ Keyword ใดๆ เลย
  return { p1: text, p2: null };
};

/**
 * ฟังก์ชันสำหรับตัดคำตามจำนวนตัวอักษร
 * @param {string} text - ข้อความที่ต้องการตัด
 * @param {number} limit - จำนวนตัวอักษรที่กำหนด (ในที่นี้คือ 20)
 */
export const splitNote = (text, limit = 20) => {
  if (!text) return { p1: "-", p2: "" };

  // ถ้าความยาวข้อความน้อยกว่าหรือเท่ากับ limit ให้ส่งกลับไปที่ p1 ทั้งหมด
  if (text.length <= limit) {
    return { p1: text, p2: "" };
  }

  // ถ้าเกิน limit ให้ตัดข้อความ 20 ตัวแรกไว้ p1 และที่เหลือไว้ p2
  return {
    p1: text.substring(0, limit),
    p2: text.substring(limit)
  };
};


let lastNotifiedId = null;
let consecutiveFailedCount = 0;

export const getNofTelegram = async (failedList) => {
  if (!Array.isArray(failedList) || failedList.length === 0) {
    consecutiveFailedCount = 0;
    return;
  }

  const latestLog = failedList[0];
  const currentLogId = latestLog.id;

  if (currentLogId === lastNotifiedId) {
    return;
  }

  lastNotifiedId = currentLogId;
  consecutiveFailedCount += 1;

  let title = `${moment().format("HH:mm")} ${t(latestLog.name_bot)} [${t(latestLog.bot_status)}]`;
  let type = "error";
  let advice = null; // เริ่มต้นด้วย null ถูกต้องแล้ว
  let { id, name } = getValidateMerchant() || {};


  if (consecutiveFailedCount >= 5) {
    type = "warning";
    title = t(`{{date}} แจ้งเตือนดึงยอดล้มเหลว`, { date: moment().format("HH:mm") });
    // 👉 แก้ไขจาก += เป็น = เพื่อไม่ให้ติดคำว่า "null" นำหน้าข้อความ
    advice = t(`ระบบฝากเงินเกิดข้อผิดพลาด กรุณาติดต่อทีม Support และปิดการใช้งานชั่วคราวจนกว่าจะได้รับการแก้ไข`);
    const txt = `
  <b>⚠️ ${`${t(latestLog.name_bot)} [${t(latestLog.bot_status)}]`} ⚠️</b>
  
  <b>Merchant:</b> <code>${name} (${id})</code>
  <b>Date/Time:</b> <code>${moment().format("YYYY-MM-DD HH:mm:ss")}</code>
  <b>Status:</b> <code>${latestLog.bot_status}</code>
  <b>message:</b> <code>${latestLog.note}</code>
  
  <b class='fs-11'>Note:</b> <code>${escapeHTML(truncate(advice, 500))}</code>
  `;
    await sendToTelegram(txt);
  }


  // จัดการรูปแบบ UI ด้วย JSX
  const messageUI = (
    <>
      <p className="mb-1 fs-13"><b>{t(`Date/Time`)}: </b>{moment(latestLog.created_at).format("YYYY-MM-DD HH:mm:ss")}</p>
      <p className="mb-1 fs-13"><b>{t("note")}: </b>{t(latestLog.note)}</p>

      {advice && (
        <>
          <br />
          <span className="text-danger fs-12" style={{ fontWeight: 'bold' }}>
            {advice}
          </span>
        </>
      )}
    </>
  );


  await NotificationSound(type, title, messageUI);
};

/**
 * ฟังก์ชันสำหรับคำนวณวงเงินคงเหลือที่ใช้ได้ในวันนี้
 * @param {Array} withdrawUsage - รายการยอดถอนของแต่ละ Merchant
 * @param {string | number} limitLeft - วงเงินสูงสุดที่ตั้งไว้ทั้งหมด
 * @return {object} - วัตถุที่มี remainingLimit (วงเงินคงเหลือ) และ totalWithdrawnToday (ยอดถอนวันนี้)
 */
export const getCalculateRemainingLimitToday = (withdrawUsage, limitLeft) => {
  // 1. แปลงค่า limitLeft ให้เป็นตัวเลขชัวร์ๆ (หากส่งมาเป็น String)
  const baseLimit = Number(limitLeft) || 0;

  // 2. ตรวจสอบว่า withdrawUsage เป็น Array หรือไม่ (ถ้าไม่ใช่ให้ใช้ Array ว่าง)
  const usageData = Array.isArray(withdrawUsage) ? withdrawUsage : [];

  // 3. รวมยอดถอนทั้งหมดของทุก Merchant
  const totalWithdrawnToday = usageData.reduce((sum, item) => {
    const amount = Number(item.totalWithdraw) || 0; // แปลง String "10090.6500" เป็น Number
    return sum + amount;
  }, 0);

  // 4. คำนวณวงเงินคงเหลือ (Limit - ยอดที่ถอนไปแล้ว)
  const remainingLimit = baseLimit - totalWithdrawnToday;

  // 5. ป้องกันกรณีติดลบ (ถ้าถอนเกินวงเงิน ให้เหลือ 0)
  return {
    remainingLimit: remainingLimit > 0 ? Intl.NumberFormat().format(remainingLimit.toFixed(2)) : 0,
    totalWithdrawnToday: Intl.NumberFormat().format(totalWithdrawnToday.toFixed(2)) // ฟอร์แมตยอดถอนให้มีคอมม่าและทศนิยม 2 ตำแหน่ง,
  };
};



// ฟังก์ชัน Helper สำหรับจัดการตัวเลข
export const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('th-TH', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0
  }).format(value);
};



/**
 * ฟังก์ชันคำนวณรายได้สุทธิ
 * @param {string|number} income - รายได้ที่เก็บจาก Agent (amountMerchet)
 * @param {string|number} platformFee - ค่าธรรมเนียมที่ต้องจ่ายระบบ (amountPlatform)
 * @returns {number} - รายได้สุทธิ
 */
export const calculateNetIncome = (income, platformFee) => {
  // แปลงค่าจาก String เป็น Number เพื่อความแม่นยำในการคำนวณ
  const incomeNum = parseFloat(income);
  const feeNum = parseFloat(platformFee);

  // ตรวจสอบว่าค่าที่ส่งมาเป็นตัวเลขที่ถูกต้องหรือไม่
  if (isNaN(incomeNum) || isNaN(feeNum)) {
    console.error("กรุณาระบุข้อมูลเป็นตัวเลขที่ถูกต้อง");
    return 0;
  }

  if (incomeNum === feeNum) {
    console.error("รายได้และค่าธรรมเนียมต้องเป็นตัวเลขบวก");
    return incomeNum; // หรือจะ return 0 ก็ได้ ขึ้นอยู่กับว่าต้องการให้แสดงอะไรในกรณีนี้
  }

  // คำนวณรายได้สุทธิ
  return incomeNum - feeNum;
}


// ฟังก์ชันสำหรับคำนวณหาจำนวนวินาทีที่เหลืออยู่
export const calculateSecondsLeft = (timeoutMillis) => {
  if (!timeoutMillis) return 0; // ค่าเริ่มต้นเผื่อกรณีไม่มีการส่งค่ามา

  const targetTime = Number(timeoutMillis);
  const currentTime = Date.now();

  // คำนวณหาผลต่าง (มิลลิวินาที) แล้วหาร 1000 เพื่อแปลงเป็นวินาที
  const secondsLeft = Math.floor((targetTime - currentTime) / 1000);

  // ใช้ Math.max เพื่อให้ค่าต่ำสุดเป็น 0 (ไม่ติดลบเมื่อหมดเวลา)
  return Math.max(0, secondsLeft);
};


/**
 * ฟังก์ชันสำหรับคำนวณเวลาที่เหลือในรูปแบบ String (ใช้สำหรับแสดงใน UI)
 * ในที่นี้จะตั้งเวลาไว้ที่ 5 นาที (300,000 มิลลิวินาที) นับจากเวลาปัจจุบัน
 */
export const StringTimeLeft = () => {
  return String(Date.now() + 5 * 60 * 1000)
}


export const getRandomInt = (length = 8) => {
  // ชุดตัวอักษรและตัวเลขที่ใช้ในการสุ่ม
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  // วนลูปสุ่มตัวอักษรตามจำนวนความยาวที่กำหนด
  for (let i = 0; i < length; i++) {
    // สุ่มดึงตำแหน่งดัชนี (Index) จากชุดตัวอักษร
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result;
}

/**
 *  ฟังก์ชันสำหรับคัดลอกรายละเอียด Merchant ไปยัง Clipboard
 * @param {object} item - Object ที่มีข้อมูล username และ password ของ Merchant
 * @param {string} merchant - ชื่อ Merchant ที่ต้องการคัดลอก
 * @returns {void} - ไม่มีค่าที่ส่งกลับ แต่จะแสดง Toast แจ้งเตือนเมื่อคัดลอกสำเร็จหรือเกิดข้อผิดพลาด
 */
export const getCopyDetailMerchant = (item, merchant) => {
  if (!item) {
    alert("not found data");
    return;
  }
  const { username, password } = item;

  if (!username || !password) {
    alert("Username or Password not found");
    return;
  }

  // สร้าง Template String ตามรูปแบบที่ต้องการ
  const txt = `URL LOGIN: ${window.location.origin}/#/login
MERCHANT: ${merchant}
PROVIDER: ${config?.web_name}
USERNAME: ${username}
PASSWORD: ${password}`;

  // ใช้ Clipboard API ในการคัดลอกข้อความ
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(txt)
      .then(() => {
        // แสดงการแจ้งเตือนเมื่อคัดลอกสำเร็จ
        showToast(
          "success",
          t("Copied to clipboard!"),
        );
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        showToast("error", "Failed to copy text.");
      });
  }
}

